export default __webpack_public_path__ + "static/media/accept-flowers-request.adad0ed1.svg";